export const formatImageUrl = (fileName, width = 200, height = 200) => {
  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? 'https://d3kskrz6tv7e9x.cloudfront.net/media'
      : 'https://d3kskrz6tv7e9x.cloudfront.net/staging';

  return `${baseUrl}/${width}x${height}/${fileName}`;
};

export const formatImageUrlFromMediaUrl = (
  mediaUrl,
  width = 200,
  height = 200
) => {
  const imageParts = mediaUrl.split('/');
  const fileName = imageParts.pop();
  if (fileName !== 'placeholder.jpg') {
    return formatImageUrl(fileName, width, height);
  }

  return mediaUrl;
};
